import {

  Navigate

} from 'react-router-dom';

import {

  useEffect,

  useState

} from 'react';

import {

  auth,

  db

} from '../config/firebase';

import {

  doc,

  getDoc

} from 'firebase/firestore';
import type { ReactNode } from 'react';

export default function AdminRoute({

  children

}: { children: ReactNode }) {

  const [loading, setLoading] =

    useState(true);

  const [isAdmin, setIsAdmin] =

    useState(false);

  useEffect(() => {

    const checkAdmin = async () => {

      const user =
        auth.currentUser;

      if (!user) {

        setLoading(false);

        return;
      }

      const userRef =
        doc(db, 'users', user.uid);

      const userSnap =
        await getDoc(userRef);

      if (userSnap.exists()) {

        const data =
          userSnap.data();

        if (
          data.role === 'admin'
        ) {

          setIsAdmin(true);
        }
      }

      setLoading(false);
    };

    checkAdmin();

  }, []);

  if (loading) {

    return (

      <div className="min-h-screen bg-[#020817] flex items-center justify-center text-white">

        Verificando acesso...

      </div>
    );
  }

  const adminVerified =

  sessionStorage.getItem(
    'admin_verified'
  );

  const verifiedAt =

  sessionStorage.getItem(
    'admin_verified_at'
  );

const THIRTY_MINUTES =

  30 * 60 * 1000;

const isExpired =

  !verifiedAt ||

  Date.now() - Number(verifiedAt)

    > THIRTY_MINUTES;

if (

  !isAdmin

  ||

  !adminVerified

  ||

  isExpired
) {

  sessionStorage.removeItem(
    'admin_verified'
  );

  sessionStorage.removeItem(
    'admin_verified_at'
  );

  return (

    <Navigate
      to="/admin-security"
    />
  );
}

  return children;
}
